import React from "react";
import styled from "styled-components";
import classNames from "classnames";

import { BUCKETS, BUCKET_COLORS } from "constants/satisfaction/data";

const BUCKET_BREAKOUT_GRAPH = [
  BUCKETS.PROMOTERS,
  BUCKETS.NEUTRALS,
  BUCKETS.DETRACTORS
];

const BUCKET_BREAKOUT_GRAPH_ELEMENTS = {
  [BUCKETS.PROMOTERS]: {
    label: "Promoters"
  },
  [BUCKETS.NEUTRALS]: {
    label: "Neutrals"
  },
  [BUCKETS.DETRACTORS]: {
    label: "Detractors"
  }
};

const BreakoutGraph = props => {
  const { responseCount, className } = props;

  const bucketPercentageValue = bucket =>
    bucket && !isNaN(bucket) ? Math.round(100 * (bucket / responseCount)) : 0;

  const bucketBreakoutGraph = BUCKET_BREAKOUT_GRAPH.map((bucket, i) => {
    return (
      <div key={`${bucket}-${i}`} className={classNames("bucket", bucket)}>
        <div className="summary">
          <div className="value">{props[bucket]}</div>
          <div className="name">
            {[BUCKET_BREAKOUT_GRAPH_ELEMENTS[bucket].label]}
          </div>
        </div>
        <div className="bar-container">
          <div
            className="bar"
            style={{
              width: `${bucketPercentageValue(props[bucket])}%`
            }}
          />
          <div className="bar-percentage">{`${bucketPercentageValue(
            props[bucket]
          )}%`}</div>
        </div>
      </div>
    );
  });

  return <div className={className}>{bucketBreakoutGraph}</div>;
};

export default styled(BreakoutGraph)`
  padding: 1rem;
  flex-basis: 50%;

  .bucket {
    display: flex;
    overflow: hidden;
    margin-top: 2rem;

    .summary {
      width: 115px;
      height: 58px;
      margin-right: 2.25rem;
      text-align: right;

      .value {
        font-size: 2.25rem;
        line-height: 1em;
      }

      .name {
        color: ${props => props.theme["$gray-30"]};
        font-size: 1rem;
        font-weight: 400;
        margin-top: 0.2em;
      }
    }

    .bar-container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      height: 58px;
      width: 100%;

      .bar {
        box-sizing: border-box;
        padding: 5px;
        height: 100%;
        border-radius: 0.25rem;
      }

      .bar-percentage {
        padding-left: 1rem;
      }
    }

    &.detractors {
      .summary {
        color: ${BUCKET_COLORS[BUCKETS.DETRACTORS].color};
      }
      .bar {
        background-color: ${BUCKET_COLORS[BUCKETS.DETRACTORS].color};
      }
      .bar-percentage {
        color: ${BUCKET_COLORS[BUCKETS.DETRACTORS].color};
      }
    }

    &.neutrals {
      .summary {
        color: ${BUCKET_COLORS[BUCKETS.NEUTRALS].color};
      }
      .bar {
        background-color: ${BUCKET_COLORS[BUCKETS.NEUTRALS].color};
      }
      .bar-percentage {
        color: ${BUCKET_COLORS[BUCKETS.NEUTRALS].color};
      }
    }

    &.promoters {
      .summary {
        color: ${BUCKET_COLORS[BUCKETS.PROMOTERS].color};
      }
      .bar {
        background-color: ${BUCKET_COLORS[BUCKETS.PROMOTERS].color};
      }
      .bar-percentage {
        color: ${BUCKET_COLORS[BUCKETS.PROMOTERS].color};
      }
    }
  }
`;
